import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import {
  HospitalityAnalytics,
  GetHospitalityAnalyticsParams,
} from "./interfaces/hospitalityAnalytics.interface";

export async function getHospitalityAnalyticsFromServer(
  params: GetHospitalityAnalyticsParams
): Promise<HospitalityAnalytics> {
  const axios = await getTokenizedAxios();
  const path = `/businesses/${params.businessId}/hospitality-analytics`;
  
  const queryParams: any = {};
  if (params.startDate) queryParams.startDate = params.startDate;
  if (params.endDate) queryParams.endDate = params.endDate;
  if (params.includeCustomerList) queryParams.includeCustomerList = params.includeCustomerList;
  if (params.limit) queryParams.limit = params.limit;
  if (params.segment && params.segment !== "all") queryParams.segment = params.segment;
  
  return axios
    .get(CONFIG.ADMIN_SERVER.BASE_URL + path, { params: queryParams })
    .then((data) => data?.data);
}

